(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button-cookies"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const cookieLink = document.getElementsByClassName('js-cookie-settings-toggle')[0];
    if (cookieLink) {
      cookieLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.privacyBanner) {
          const cp = window.privacyBanner;
          if (typeof cp.showPreferences === 'function') {
            cp.showPreferences();
          }
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    function getUpsellCards(track) {
  return Array.from(track.querySelectorAll('.product-card'));
}

function syncIndexFromScroll(track) {
  var cards = getUpsellCards(track);
  if (!cards.length) return;
  var trackLeft = track.getBoundingClientRect().left;
  var index = 0;
  var minDist = Infinity;
  cards.forEach(function (card, i) {
    var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
    if (dist < minDist) { minDist = dist; index = i; }
  });
  track.dataset.scrollIndex = index;
  updateUpsellButtons(track);
}

function updateUpsellButtons(track) {
  var upsell = track.closest('.cart-upsell');
  if (!upsell) return;
  var prev = upsell.querySelector('.js-scroll-prev');
  var next = upsell.querySelector('.js-scroll-next');
  if (!prev || !next) return;
  var index = parseInt(track.dataset.scrollIndex || '0', 10);
  var count = getUpsellCards(track).length;
  prev.disabled = index <= 0;
  next.disabled = index >= count - 1;
}

// Clic prev/next
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.js-scroll-prev, .js-scroll-next');
  if (!btn || btn.disabled) return;
  var upsell = btn.closest('.cart-upsell');
  if (!upsell) return;
  var track = upsell.querySelector('.cart-upsell__products');
  if (!track) return;
  var cards = getUpsellCards(track);
  if (!cards.length) return;
  var index = parseInt(track.dataset.scrollIndex || '0', 10);
  var dir = btn.matches('.js-scroll-prev') ? -1 : 1;
  index = Math.max(0, Math.min(cards.length - 1, index + dir));
  track.dataset.scrollIndex = index;
  cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  updateUpsellButtons(track);
});

// Scroll trackpad/touch — scrollend + fallback debounce
var scrollTimers = new WeakMap();
document.addEventListener('scrollend', function (e) {
  var track = e.target;
  if (!track.classList || !track.classList.contains('cart-upsell__products')) return;
  syncIndexFromScroll(track);
}, { capture: true });

document.addEventListener('scroll', function (e) {
  var track = e.target;
  if (!track.classList || !track.classList.contains('cart-upsell__products')) return;
  clearTimeout(scrollTimers.get(track));
  scrollTimers.set(track, setTimeout(function () { syncIndexFromScroll(track); }, 150));
}, { capture: true, passive: true });

function initUpsellButtons(upsell) {
  var track = upsell.querySelector('.cart-upsell__products');
  if (!track) return;
  track.dataset.scrollIndex = '0';
  updateUpsellButtons(track);
}

document.querySelectorAll('.cart-upsell').forEach(initUpsellButtons);
document.addEventListener('cart:refresh', function () {
  document.querySelectorAll('.cart-upsell').forEach(initUpsellButtons);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  function closePanel(panel) {
    panel.setAttribute('aria-hidden', 'true');
    var inner = panel.querySelector('.drawer__inner');
    if (inner) inner.inert = true;
    var toggle = document.querySelector('.js-drawer-toggle[data-target="#' + panel.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('.drawer[aria-hidden="false"]')) document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.js-drawer-toggle');
    if (toggle) {
      var targetPanel = document.querySelector(toggle.dataset.target);
      if (!targetPanel) return;
      e.preventDefault();
      targetPanel.setAttribute('aria-hidden', 'false');
      var inner = targetPanel.querySelector('.drawer__inner');
      if (inner) inner.inert = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      return;
    }

    var closeBtn = e.target.closest('.js-drawer-close');
    if (closeBtn) {
      var panel = closeBtn.closest('.drawer');
      if (panel) closePanel(panel);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panels = document.querySelectorAll('.drawer[aria-hidden="false"]');
    if (!panels.length) return;
    closePanel(panels[panels.length - 1]);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (function () {
  const form = document.getElementById('facets-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    const data = new FormData(form);

    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.') || key === 'sort_by') url.searchParams.delete(key);
    }

    for (const [key, value] of data.entries()) {
      if (value !== '') url.searchParams.append(key, value);
    }

    window.location.href = url.toString();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.gallery').forEach((gallery) => {
  let isDown = false;
  let startX;
  let scrollLeft;
  let velocity = 0;
  let lastX;
  let lastTime;
  let rafId;

  function stopMomentum() {
    cancelAnimationFrame(rafId);
    velocity = 0;
  }

  function applyMomentum() {
    if (Math.abs(velocity) < 0.5) {
      stopMomentum();
      return;
    }
    gallery.scrollLeft += velocity;
    velocity *= 0.92;
    rafId = requestAnimationFrame(applyMomentum);
  }

  gallery.addEventListener('mousedown', (e) => {
    stopMomentum();
    isDown = true;
    gallery.classList.add('is-dragging');
    startX = e.pageX - gallery.offsetLeft;
    scrollLeft = gallery.scrollLeft;
    lastX = e.pageX;
    lastTime = Date.now();
  });

  gallery.addEventListener('mouseleave', () => {
    if (!isDown) return;
    isDown = false;
    gallery.classList.remove('is-dragging');
    rafId = requestAnimationFrame(applyMomentum);
  });

  gallery.addEventListener('mouseup', () => {
    isDown = false;
    gallery.classList.remove('is-dragging');
    rafId = requestAnimationFrame(applyMomentum);
  });

  gallery.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - gallery.offsetLeft;
    const walk = (x - startX) * 1.5;
    gallery.scrollLeft = scrollLeft - walk;

    const now = Date.now();
    const dt = now - lastTime || 1;
    velocity = ((e.pageX - lastX) / dt) * 16 * -1.5;
    lastX = e.pageX;
    lastTime = now;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-main"] && !Shopify.designMode) return;
  try {
    const navToggle = document.getElementsByClassName('js-main-menu-toggle')[0];
const navOverlay = document.getElementById('menu-main');

class Nav {
  constructor(toggle, overlay) {
    this.html = document.documentElement;
    this.toggle = toggle;
    this.overlay = overlay;
    this.closeBtn = document.getElementsByClassName('js-menu-main-close')[0];
    this.desktopMQ = window.matchMedia('(min-width: 90rem)');
    this.classNavOpen = "menu-main-open";
    this.init();
  }

  init() {
    this.applyInert();

    this.toggle.addEventListener('click', () => {
      this.html.classList.contains(this.classNavOpen) ? this.close() : this.open();
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', e => this.onKeydown(e));
    this.overlay.addEventListener('keydown', e => this.onFocusTrap(e));
    this.desktopMQ.addEventListener('change', () => this.onResize());
  }

  applyInert() {
    this.overlay.inert = !this.desktopMQ.matches && !this.html.classList.contains(this.classNavOpen);
  }

  open() {
    this.html.classList.add(this.classNavOpen);
    this.toggle.setAttribute('aria-expanded', 'true');
    this.overlay.removeAttribute('aria-hidden');
    this.overlay.inert = false;
    this.closeBtn?.focus();
  }

  close() {
    this.html.classList.remove(this.classNavOpen);
    this.toggle.setAttribute('aria-expanded', 'false');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.overlay.inert = true;
    this.toggle.focus();
    this.overlay.querySelectorAll('.js-nav-expand-toggle').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
    });
    this.overlay.querySelectorAll('.nav-expand.is-open').forEach(el => {
      el.classList.remove('is-open');
    });
    this.html.classList.remove('nav-expand-open');
  }

  onKeydown(e) {
    if (e.key === 'Escape' && this.html.classList.contains(this.classNavOpen)) {
      this.close();
    }
  }

  onFocusTrap(e) {
    if (e.key !== 'Tab') return;
    const focusable = [...this.overlay.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )];
    if (focusable.length < 2) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  onResize() {
    if (this.desktopMQ.matches) {
      this.html.classList.remove(this.classNavOpen);
      this.toggle.setAttribute('aria-expanded', 'false');
      this.overlay.removeAttribute('aria-hidden');
      this.overlay.inert = false;
    } else {
      this.overlay.setAttribute('aria-hidden', 'true');
      this.overlay.inert = true;
    }
  }
}

if (navToggle && navOverlay) {
  new Nav(navToggle, navOverlay);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal"] && !Shopify.designMode) return;
  try {
    (function () {
  function initModal(dialog) {
    const id = dialog.id;
    const toggles = document.querySelectorAll('.js-modal-toggle[data-target="#' + id + '"]');

    function open() {
      if (document.startViewTransition) {
        document.startViewTransition(() => dialog.showModal());
      } else {
        dialog.showModal();
      }
    }

    function close() {
      if (!dialog.open) return;
      if (document.startViewTransition) {
        document.startViewTransition(() => dialog.close());
      } else {
        dialog.close();
      }
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    dialog.querySelectorAll('.js-modal-close').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Close on backdrop click (click outside modal__inner)
    dialog.addEventListener('click', function (e) {
      const inner = dialog.querySelector('.modal__inner');
      if (!inner) return;
      const rect = inner.getBoundingClientRect();
      const isInner = (
        e.clientX >= rect.left && e.clientX <= rect.right &&
        e.clientY >= rect.top  && e.clientY <= rect.bottom
      );
      if (!isInner) close();
    });

    // Restore focus to toggle on close
    dialog.addEventListener('close', function () {
      if (toggles.length) toggles[0].focus();
    });
  }

  document.querySelectorAll('.modal').forEach(initModal);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-expand"] && !Shopify.designMode) return;
  try {
    const navExpandToggles = document.querySelectorAll('.js-nav-expand-toggle');

class NavExpand {
  constructor(toggles) {
    this.html = document.documentElement;
    this.toggles = [...toggles];
    this.isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    this.desktopMQ = window.matchMedia('(min-width: 90rem)');
    this.init();
  }

  isDesktop() {
    return this.desktopMQ.matches;
  }

  init() {
    this.toggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      const expand = this.getExpand(toggle);
      if (expand && !expand.id) {
        expand.id = 'nav-expand-' + Math.random().toString(36).slice(2, 7);
      }
      if (expand) toggle.setAttribute('aria-controls', expand.id);

      const li = toggle.closest('li');
      if (li) {
        li.addEventListener('mouseenter', () => {
          if (this.isHoverDevice && this.isDesktop()) this.onHoverOpen(toggle);
        });
      }
      toggle.addEventListener('click', e => {
        e.preventDefault();
        if (this.isHoverDevice && this.isDesktop()) return;
        this.onToggleClick(e, toggle);
      });
      toggle.addEventListener('keydown', e => {
        if (e.key === ' ') { e.preventDefault(); this.onToggleClick(e, toggle); }
      });
    });

    const header = this.toggles[0]?.closest('header');
    if (header) {
      header.addEventListener('mouseleave', () => {
        if (!this.isDesktop()) return;
        const focused = document.activeElement;
        if (focused && header.contains(focused) && focused.matches('input, textarea, select')) return;
        this.onHeaderMouseLeave();
      });
    }

    document.querySelectorAll('.js-nav-expand-back').forEach(btn => {
      btn.addEventListener('click', () => this.onBackClick(btn));
    });

    document.addEventListener('keydown', e => this.onKeydown(e));
  }

  getExpand(toggle) {
    return toggle.parentElement?.querySelector('.nav-expand') ?? null;
  }

  closeAll(except = null) {
    this.toggles.forEach(t => {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      const expand = this.getExpand(t);
      if (expand) { expand.classList.remove('is-open'); expand.inert = true; }
    });
  }

  isAnyOpen() {
    return this.toggles.some(t => t.getAttribute('aria-expanded') === 'true');
  }

  onHoverOpen(toggle) {
    this.closeAll(toggle);
    toggle.setAttribute('aria-expanded', 'true');
    const expand = this.getExpand(toggle);
    if (expand) { expand.classList.add('is-open'); expand.inert = false; }
    this.html.classList.add('nav-expand-open');
  }

  onHeaderMouseLeave() {
    this.closeAll();
    this.html.classList.remove('nav-expand-open');
  }

  onToggleClick(e, toggle) {
    e.preventDefault();
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    this.closeAll(isOpen ? null : toggle);
    if (isOpen) {
      toggle.setAttribute('aria-expanded', 'false');
      this.getExpand(toggle)?.classList.remove('is-open');
      toggle.focus();
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      const expand = this.getExpand(toggle);
      if (expand) {
        expand.classList.add('is-open');
        expand.inert = false;
        const input = expand.querySelector('input[type="text"], input[type="search"]');
        if (input) setTimeout(() => input.focus(), 50);
      }
    }
    this.html.classList.toggle('nav-expand-open', this.isAnyOpen());
  }

  onBackClick(btn) {
    const expand = btn.closest('.nav-expand');
    if (!expand) return;
    expand.classList.remove('is-open');
    expand.inert = true;
    const toggle = document.querySelector(`[aria-controls="${expand.id}"]`);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    if (!this.isAnyOpen()) this.html.classList.remove('nav-expand-open');
  }

  onKeydown(e) {
    if (e.key !== 'Escape' || !this.html.classList.contains('nav-expand-open')) return;
    const openToggle = this.toggles.find(t => t.getAttribute('aria-expanded') === 'true');
    this.closeAll();
    this.html.classList.remove('nav-expand-open');
    openToggle?.focus();
  }
}

if (navExpandToggles.length) {
  new NavExpand(navExpandToggles);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-back-in-stock"] && !Shopify.designMode) return;
  try {
    class BackInStockForm {
  static SELECTOR = '.js-back-in-stock-form';
  static ENDPOINT = 'https://a.klaviyo.com/client';
  static REVISION = '2026-07-15';

  static initAll() {
    document.querySelectorAll(this.SELECTOR).forEach((form) => new BackInStockForm(form));
  }

  constructor(form) {
    this.form = form;
    this.email = form.querySelector('[name="email"]');
    this.publicKey = form.dataset.publicKey;
    this.locale = form.dataset.locale;
    this.catalogVariantId = form.dataset.catalogVariantId;
    if (!this.email || !this.publicKey || !this.catalogVariantId) return;

    this.dialog = form.closest('dialog');
    const scope = this.dialog || document;
    this.successMessage = scope.querySelector('.js-back-in-stock-success');
    this.errorMessage = scope.querySelector('.js-back-in-stock-error');

    this.form.addEventListener('submit', (e) => this.onSubmit(e));
    if (this.dialog) this.dialog.addEventListener('close', () => this.reset());
  }

  post(resource, body) {
    const url = `${BackInStockForm.ENDPOINT}/${resource}/?company_id=${encodeURIComponent(this.publicKey)}`;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: BackInStockForm.REVISION,
      },
      body: JSON.stringify(body),
    });
  }

  async subscribe(email) {
    const response = await this.post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email } } },
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: this.catalogVariantId },
          },
        },
      },
    });
    if (response.ok) return;

    // Klaviyo answers 404 "variant_not_found" when the composite id does not match a variant
    // of its catalog, which is the first thing to check when the form stops working.
    const detail = await response.text().catch(() => '');
    throw new Error(`back-in-stock-subscriptions returned ${response.status} ${detail}`);
  }

  // Best effort: the subscription is already recorded, a missing locale only costs the
  // language split in the Klaviyo flow.
  setLocale(email) {
    if (!this.locale) return;
    this.post('profiles', {
      data: { type: 'profile', attributes: { email, locale: this.locale } },
    }).catch(() => {});
  }

  showMessage(message) {
    [this.successMessage, this.errorMessage].forEach((el) => {
      if (el) el.hidden = el !== message;
    });
  }

  reset() {
    this.showMessage(null);
    this.form.hidden = false;
    this.form.reset();
  }

  async onSubmit(e) {
    e.preventDefault();
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.form.setAttribute('aria-busy', 'true');
    try {
      await this.subscribe(this.email.value.trim());
      this.setLocale(this.email.value.trim());
      this.form.hidden = true;
      this.showMessage(this.successMessage);
    } catch (err) {
      console.error('BackInStockForm:', err);
      this.showMessage(this.errorMessage);
    } finally {
      this.form.removeAttribute('aria-busy');
    }
  }
}

BackInStockForm.initAll();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    class ProductForm {
  static SELECTOR = '.product-form';
  static ADDITIONAL_SELECTOR = '[data-additional-product-variant-id]';

  static initAll() {
    document.querySelectorAll(this.SELECTOR).forEach((wrapper) => new ProductForm(wrapper));
  }

  constructor(wrapper) {
    this.form = wrapper.querySelector('form');
    if (!this.form) return;
    this.additionalInputs = this.form.querySelectorAll(ProductForm.ADDITIONAL_SELECTOR);
    if (!this.additionalInputs.length) return;
    this.form.addEventListener('submit', (e) => this.onSubmit(e), { capture: true });
  }

  isInputActive(input) {
    if (input.type === 'checkbox') return input.checked;
    const parentId = input.dataset.additionalParent;
    if (!parentId) return true;
    const parent = this.form.querySelector('#' + parentId);
    return parent && parent.type === 'checkbox' ? parent.checked : false;
  }

  collectAdditionalIds() {
    const ids = new Set();
    this.additionalInputs.forEach((input) => {
      if (!this.isInputActive(input)) return;
      const id = parseInt(input.dataset.additionalProductVariantId, 10);
      if (id) ids.add(id);
    });
    return ids;
  }

  async fetchCartVariantIds() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    return new Set(cart.items.map((i) => i.variant_id));
  }

  async onSubmit(e) {
    const additionalIds = this.collectAdditionalIds();
    if (!additionalIds.size) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const formData = new FormData(this.form);
    const mainVariantId = parseInt(formData.get('id'), 10);
    const quantity = parseInt(formData.get('quantity') || '1', 10);
    if (!mainVariantId) return;

    try {
      const cartVariantIds = await this.fetchCartVariantIds();
      const items = [{ id: mainVariantId, quantity }];
      additionalIds.forEach((id) => {
        if (id !== mainVariantId && !cartVariantIds.has(id)) {
          items.push({ id, quantity: 1 });
        }
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const error = await response.json();
        console.error('ProductForm: cart/add.js error', error);
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:add'));
    } catch (err) {
      console.error('ProductForm: fetch failed', err);
    }
  }
}

ProductForm.initAll();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const controls = btn.closest('.product-quantity__controls');
      const input = controls.querySelector('.product-quantity__input');
      const step = parseInt(input.step) || 1;
      const min = parseInt(input.min) || 1;
      const current = parseInt(input.value) || min;

      if (btn.hasAttribute('data-quantity-minus')) {
        input.value = Math.max(min, current - step);
      } else {
        input.value = current + step;
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky"] && !Shopify.designMode) return;
  try {
    (function () {
  const sticky = document.querySelector('.js-product-sticky');
  const from = document.querySelector('.product.container');
  const to = document.querySelector('.block-featured-products') ?? document.querySelector('footer[role="contentinfo"]');
  if (!sticky || !from) return;

  let fromBottom = 0;
  let toTop = Infinity;

  function recalculate() {
    fromBottom = from.getBoundingClientRect().bottom + window.scrollY - window.innerHeight / 2;
    toTop = to
      ? to.getBoundingClientRect().top + window.scrollY
      : Infinity;
  }

  function update() {
    const scrollY = window.scrollY;
    const shouldShow = scrollY > fromBottom && scrollY + window.innerHeight < toTop;
    sticky.classList.toggle('show', shouldShow);
  }

  recalculate();
  update();

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => { recalculate(); update(); }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.js-product-variants-selector').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = this.closest('form');
      if (!form) return;
      var btn = form.querySelector('.js-add-to-cart');
      if (!btn) return;
      var list = this.closest('.product-variants');
      var available = this.dataset.available === 'true';
      if (available) {
        btn.textContent = list.dataset.addToCart + ' — ' + this.dataset.price;
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      } else {
        btn.textContent = list.dataset.comingSoon;
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-locator"] && !Shopify.designMode) return;
  try {
    (function () {
  const STORE_LOCATOR_SELECTOR = '[data-store-locator-root]';
  const MARKER_CLUSTERER_URL =
    'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';

  let googleMapsLoaderPromise;
  let markerClustererPromise;

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), {
          once: true,
        });
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.defer = true;
      script.addEventListener(
        'load',
        () => {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true },
      );
      script.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), {
        once: true,
      });
      document.head.appendChild(script);
    });
  }

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      return Promise.resolve();
    }
    if (googleMapsLoaderPromise) return googleMapsLoaderPromise;

    googleMapsLoaderPromise = new Promise((resolve, reject) => {
      const g = { key: apiKey, v: 'weekly' };
      let h;
      let a;
      let k;
      const p = 'The Google Maps JavaScript API';
      const c = 'google';
      const l = 'importLibrary';
      const q = '__ib__';
      const m = document;
      const b = window;
      const googleObj = b[c] || (b[c] = {});
      const mapsObj = googleObj.maps || (googleObj.maps = {});
      const r = new Set();
      const e = new URLSearchParams();
      const u = function () {
        return (
          h ||
          (h = new Promise(function (f, n) {
            a = m.createElement('script');
            e.set('libraries', Array.from(r).join(','));
            for (k in g) {
              e.set(k.replace(/[A-Z]/g, function (t) {
                return '_' + t[0].toLowerCase();
              }), g[k]);
            }
            e.set('callback', c + '.maps.' + q);
            a.src = 'https://maps.googleapis.com/maps/api/js?' + e.toString();
            mapsObj[q] = f;
            a.onerror = function () {
              n(new Error(p + ' could not load.'));
            };
            a.nonce = m.querySelector('script[nonce]') ? m.querySelector('script[nonce]').nonce : '';
            m.head.appendChild(a);
          }))
        );
      };

      if (mapsObj[l]) {
        resolve();
        return;
      }

      mapsObj[l] = function (f) {
        r.add(f);
        return u().then(function () {
          return mapsObj[l](f);
        });
      };

      u().then(resolve).catch(reject);
    });

    return googleMapsLoaderPromise;
  }

  function loadMarkerClusterer() {
    if (window.markerClusterer && window.markerClusterer.MarkerClusterer) {
      return Promise.resolve(window.markerClusterer.MarkerClusterer);
    }
    if (markerClustererPromise) return markerClustererPromise;
    markerClustererPromise = loadScript(MARKER_CLUSTERER_URL).then(function () {
      if (!window.markerClusterer || !window.markerClusterer.MarkerClusterer) {
        throw new Error('MarkerClusterer did not initialize');
      }
      return window.markerClusterer.MarkerClusterer;
    });
    return markerClustererPromise;
  }

  async function fetchAllPartners(shopDomain, storefrontToken) {
    const url = `https://${shopDomain}/api/2024-01/graphql.json`;
    const locations = [];
    let cursor = null;
    let hasNextPage = true;

    while (hasNextPage) {
      const query = `
        query Partners($cursor: String) {
          metaobjects(type: "partners", first: 250, after: $cursor) {
            edges {
              node {
                fields {
                  key
                  value
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      `;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken,
        },
        body: JSON.stringify({ query, variables: { cursor } }),
      });

      const json = await response.json();
      const metaobjects = json.data.metaobjects;

      for (const edge of metaobjects.edges) {
        const fields = {};
        for (const field of edge.node.fields) {
          fields[field.key] = field.value;
        }
        if (fields.lat && fields.lng) {
          locations.push(fields);
        }
      }

      hasNextPage = metaobjects.pageInfo.hasNextPage;
      cursor = metaobjects.pageInfo.endCursor;
    }

    return locations;
  }

  function setResult(resultElements, store) {
    const { panel, name, address, link } = resultElements;
    if (!store) {
      panel.hidden = true;
      name.textContent = '';
      address.textContent = '';
      link.setAttribute('href', '#');
      return;
    }
    name.textContent = store.name || '';
    address.textContent = [store.address, store.city, store.zipcode].filter(Boolean).join(' ');
    link.setAttribute(
      'href',
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.lat + ',' + store.lng)}`
    );
    panel.hidden = false;
  }

  async function initStoreLocator(root) {
    const apiKey = root.dataset.apiKey;
    const mapId = root.dataset.mapId || '';
    const shopDomain = root.dataset.shopDomain;
    const storefrontToken = root.dataset.storefrontToken;
    if (!apiKey || !shopDomain || !storefrontToken) return;

    const mapNode = root.querySelector('[data-store-locator-map]');
    const inputNode = root.querySelector('[data-store-locator-search-input]');
    const resultPanel = root.querySelector('[data-store-locator-result]');
    const resultName = root.querySelector('[data-store-locator-result-name]');
    const resultAddress = root.querySelector('[data-store-locator-result-address]');
    const resultLink = root.querySelector('[data-store-locator-result-link]');
    const closeButton = root.querySelector('[data-store-locator-result-close]');

    if (!mapNode || !inputNode || !resultPanel || !resultName || !resultAddress || !resultLink || !closeButton) {
      return;
    }

    const [parsedLocations, , MarkerClusterer] = await Promise.all([
      fetchAllPartners(shopDomain, storefrontToken),
      loadGoogleMaps(apiKey),
      loadMarkerClusterer(),
    ]);

    const mapsLibrary = await window.google.maps.importLibrary('maps');
    const markerLibrary = await window.google.maps.importLibrary('marker');
    const placesLibrary = await window.google.maps.importLibrary('places');

    const Map = mapsLibrary.Map;
    const AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;
    const Autocomplete = placesLibrary.Autocomplete;

    const map = new Map(mapNode, {
      zoom: 3,
      center: { lat: 46.2276, lng: 2.2137 },
      gestureHandling: 'cooperative',
      disableDefaultUI: true,
      mapId: mapId,
    });

    const resultElements = {
      panel: resultPanel,
      name: resultName,
      address: resultAddress,
      link: resultLink,
    };

    const markers = parsedLocations.map(function (store) {
      const pinPosition = {
        lng: parseFloat(store.lng),
        lat: parseFloat(store.lat),
      };

      const pin = document.createElement('span');
      pin.className = 'store-locator__pin';
      pin.setAttribute('aria-hidden', 'true');

      const marker = new AdvancedMarkerElement({
        map: map,
        position: pinPosition,
        content: pin,
        gmpClickable: true,
      });

      marker.addListener('click', function () {
        map.setCenter(pinPosition);
        map.setZoom(14);
        setResult(resultElements, store);
      });
      return marker;
    });

    map.addListener('zoom_changed', function () {
      if ((map.getZoom() || 0) <= 6) {
        setResult(resultElements, null);
      }
    });

    const renderer = {
      render: function (clusterData) {
        const clusterPin = document.createElement('div');
        clusterPin.className = 'store-locator__cluster';
        const label = document.createElement('span');
        label.textContent = String(clusterData.count);
        clusterPin.appendChild(label);
        return new AdvancedMarkerElement({
          map: map,
          position: clusterData.position,
          content: clusterPin,
          title: 'Zoom in to view stores in this area',
          zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + clusterData.count,
        });
      },
    };

    new MarkerClusterer({ map: map, markers: markers, renderer: renderer });

    const autocomplete = new Autocomplete(inputNode, {
      types: ['geocode'],
    });
    autocomplete.setFields(['address_components', 'geometry', 'name']);

    autocomplete.addListener('place_changed', function () {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;
      if (place.geometry.viewport) {
        const bounds = new window.google.maps.LatLngBounds();
        bounds.extend(place.geometry.viewport.getSouthWest());
        bounds.extend(place.geometry.viewport.getNorthEast());
        map.fitBounds(bounds);
        return;
      }
      if (place.geometry.location) {
        map.setCenter(place.geometry.location);
        map.setZoom(15);
      }
    });

    closeButton.addEventListener('click', function () {
      setResult(resultElements, null);
    });
  }

  function initAll() {
    const roots = document.querySelectorAll(STORE_LOCATOR_SELECTOR);
    roots.forEach(function (root) {
      initStoreLocator(root).catch(function (error) {
        console.error('Store Locator Error:', error);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    class Video {
  constructor(el) {
    this.el = el;
    this.observe();
  }

  observe() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.load();
          observer.unobserve(this.el);
        }
      });
    });
    observer.observe(this.el);
  }

  load() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const hasMobile = Array.from(this.el.children).some(
      (s) => s.tagName === 'SOURCE' && s.hasAttribute('data-src_mobile')
    );

    Array.from(this.el.children).forEach((source) => {
      if (source.tagName !== 'SOURCE') return;
      if (isMobile && hasMobile && source.hasAttribute('data-src_mobile')) {
        source.src = source.dataset.src_mobile;
      } else if (source.hasAttribute('data-src')) {
        source.src = source.dataset.src;
      }
    });

    this.el.load();
    this.el.classList.remove('is-lazy');
  }
}

document.querySelectorAll('.js-video.is-lazy').forEach((el) => new Video(el));
  } catch(e) { console.error(e); }
})();

})();
